import { AssetsState } from './state';
import { assetsInitialState } from './initial-state';
import { AssetsActions } from './action-creators';
import * as actions from './actions';
import { AssetValidationResults } from '@services/asset/types/asset-validation-results';

export const assetsReducer = (
  state: AssetsState = assetsInitialState,
  action: AssetsActions
): AssetsState => {
  switch (action.type) {
    case actions.CLEAR_ASSETS: {
      return {
        assets: {},
        statuses: {},
      };
    }

    case actions.START_ASSET_UPLOAD: {
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.upload.id]: action.upload,
        },
      };
    }

    case actions.UPDATE_ASSET_UPLOAD: {
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
            [action.key]: action.value,
          },
        },
      };
    }

    case actions.FINISH_ASSET_UPLOAD: {
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
            status: 'done',
          },
        },
      };
    }

    case actions.FINISH_ASSET_REPLACE_UPLOAD: {
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
            status: 'done',
          },
        },
      };
    }

    case actions.GET_ASSET_STATUS_SUCCESS: {
      const statuses: { [id: string]: AssetValidationResults } =
        action.results.reduce(
          (memo, status) => ({
            ...memo,
            [status.assetId]: status,
          }),
          {}
        );

      return {
        ...state,
        statuses: {
          ...state.statuses,
          ...statuses,
        },
      };
    }

    case actions.REMOVE_ASSET_UPLOAD: {
      const newState: AssetsState = {
        ...state,
        assets: {},
      };

      Object.keys(state).forEach((key) => {
        if (!action.assetIds.includes(key)) {
          newState.assets[key] = { ...state.assets[key] };
        }
      });

      return newState;
    }

    default: {
      return { ...state };
    }
  }
};
